import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { GridViewModel } from '@models/module/grid';
import { ScreenModel, ScreenTypeEnum } from '@module-definition/screen/common';
import { HttpService } from '@shared/services';

export const isStartScreen = (screen: ScreenModel): boolean =>
  screen.type === ScreenTypeEnum.Entity || !!screen.isStartScreen;

export const isTransitionForm = (screen: ScreenModel): boolean =>
  screen.type === ScreenTypeEnum.Action && !screen.isStartScreen;

@Injectable({ providedIn: 'root' })
export class ModuleScreensService {
  private readonly http = inject(HttpService);

  private moduleHeaders(moduleId: number) {
    return { moduleId: moduleId.toString() };
  }

  search(moduleId: number): Observable<ScreenModel[]> {
    return this.http
      .post<
        GridViewModel<ScreenModel[]>
      >('_api/Screen/Search', {}, { useLoader: false, httpOptions: { headers: this.moduleHeaders(moduleId) } })
      .pipe(map(result => result?.data ?? []));
  }

  create(moduleId: number, body: Partial<ScreenModel>): Observable<number> {
    return this.http.post<number>('_api/Screen/Create', body, {
      useLoader: false,
      httpOptions: { headers: this.moduleHeaders(moduleId) },
    });
  }

  update(moduleId: number, body: ScreenModel) {
    return this.http.put('_api/Screen/Update', body, {
      useLoader: false,
      httpOptions: { headers: this.moduleHeaders(moduleId) },
    });
  }

  delete(moduleId: number, id: number) {
    const params = this.http.buildHttpParams({ id });
    return this.http.put(
      '_api/Screen/Delete',
      {},
      {
        useLoader: false,
        httpOptions: { params, headers: this.moduleHeaders(moduleId) },
      },
    );
  }
}
